/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react"
import Header from "../../components/Header"
import * as S from "./styled"

import Container from "../../components/Container"
import BlockInfo from "../../components/BlockInfo"

import calendar from "../../assets/icons/calendar.png"
import location from "../../assets/icons/pin.png"
import userSafety from "../../assets/icons/user-safety.png"

import TicketsControl from "../../components/TicketsControl"
import Footer from "../../components/Footer"
import { Api, checkTokenExpiration } from "../../api"
import { TTicketDisposal } from "../../utils/@types/data/ticket"
import { parseDisposalTickets } from "../../utils/tb/ticketsToDisposal"
import getStore from "../../store"
import { getDatePeriod, getHours } from "../../utils/tb/getDatePeriod"
import { useLocation, useNavigate, useNavigationType } from "react-router-dom"
import { TEventData } from "../../utils/@types/data/event"
import { parseEmojis } from "../../utils/tb/text"

const Home = () => {
  const lctn = useLocation()
  const navigate = useNavigate()
  const navigationType = useNavigationType()

  const eventData = sessionStorage.getItem("event")

  const event = eventData ? (JSON.parse(eventData) as TEventData) : null

  const { controllers, user } = getStore()

  const [tickets, setTickets] = useState<TTicketDisposal[]>([])
  const [groups, setGroups] = useState<{ id: string; name: string }[]>([])

  useEffect(() => {
    if (navigationType === "POP") {
      if (lctn.state?.backRoute) {
        navigate(lctn.state.backRoute, { replace: true })
      }
    }
  }, [navigationType])

  const loadEventData = async () => {
    if (event) {
      try {
        const req = await Api.get.eventInfo({ eventId: event?.id })

        if (req.ok) {
          const data = req.data

          if (data.is_ecommerce) {
            controllers.event.setData(req.data)
            sessionStorage.setItem("event", JSON.stringify(req.data))
          } else {
            controllers.event.clear()
            navigate("/eventSelect")
          }
        }
      } catch (error) {
        alert("Erro ao carregar os tickets")
      }
    } else navigate("/eventSelect")
  }

  const fetchTickets = async () => {
    if (event) {
      try {
        const req = await Api.get.products({ eventId: event?.id })

        if (req.ok) {
          const list = req.data.list

          let groupsList: { id: string; name: string }[] = []

          list.forEach((i) => {
            if (i.mesa_type) return
            if (groupsList.every((g) => g.id !== i.group_id))
              groupsList.push({
                id: i.group_id,
                name: i.group_name,
              })
          })

          setGroups(groupsList)

          const parsedTickets = parseDisposalTickets(
            list.filter((t) =>
              t.active !== undefined ? (Boolean(t.active) ? t : null) : t,
            ),
          )

          setTickets(parsedTickets)
        }
      } catch (error) {
        alert("Erro ao carregar os tickets")
      }
    }
  }

  const checkTokenTime = () => {
    if (user) {
      try {
        const token = localStorage.getItem("token")

        if (token) {
          const isTokenExpired = checkTokenExpiration(token)
          if (isTokenExpired) {
            localStorage.removeItem("token")
            controllers.user.clear()
            localStorage.removeItem("token")
            sessionStorage.removeItem("user")
          }
        }
      } catch (error) {}
    }
  }

  useEffect(() => {
    localStorage.removeItem("payed")
    localStorage.removeItem("expired")
    localStorage.removeItem("paymentSession")

    checkTokenTime()

    if (event) {
      if (!lctn.state?.fromSelect) loadEventData()
      if (tickets.length === 0) fetchTickets()
    } else navigate("/eventSelect", { replace: true })
  }, [])

  return (
    <S.Page>
      <Header />
      <S.Hero>
        <img
          src={event?.event_banner}
          alt={""}
          className={"blured blured-horizontal"}
        />
        <img
          src={event?.event_banner_vertical}
          alt={""}
          className={"blured blured-vertical"}
        />
        <Container>
          <S.BannerAndTicketsArea>
          <S.ImageContainer
            $hasBanner={!!event?.event_banner}
            $hasVerticalBanner={!!event?.event_banner_vertical}
          >
            <img
              src={event?.event_banner}
              alt={event?.name ?? ""}
              className={`event-banner`}
            />
            <img
              src={event?.event_banner_vertical}
              alt={event?.name ?? ""}
              className={`event-banner-vertical`}
            />
          </S.ImageContainer>

          <TicketsControl
            showByGroup={groups.length > 1}
            groups={groups}
            tickets={tickets}
            setTickets={setTickets}
            inline={true}
          />
          </S.BannerAndTicketsArea>
        </Container>
      </S.Hero>

      <Container>
        <S.EventDataArea>
          <S.MainData>
            <S.EventName>{event?.name}</S.EventName>
            <S.Blocks>
              <BlockInfo
                k={3}
                title="Data e Hora"
                description={[
                  getDatePeriod(
                    event?.date_ini as string,
                    event?.date_end as string,
                  ),
                  event?.date_ini
                    ? getHours(
                        new Date(
                          event?.date_ini.slice(
                            0,
                            event?.date_ini.indexOf("T"),
                          ) +
                            "T" +
                            event?.time_ini +
                            ".000Z",
                        ),
                      )
                    : event?.time_ini
                      ? event.time_ini.slice(0, 5)
                      : "Dia todo",
                ]}
                icon={<img src={calendar} alt={""} width={84} />}
              />
              <BlockInfo
                k={4}
                title="Localização"
                description={[
                  `${event?.local}. ${event?.address}`,
                  `${event?.city} - ${event?.uf}`,
                ]}
                icon={<img src={location} alt={""} width={84} />}
              />
              {Boolean(event?.has_age) && (
                <BlockInfo
                  title="Informações adicionais"
                  description={["Faixa etária", String(event?.age)]}
                  icon={
                    <img
                      src={userSafety}
                      className="userSafety"
                      alt={""}
                      height={48}
                      width={48}
                    />
                  }
                />
              )}
            </S.Blocks>
          </S.MainData>
        </S.EventDataArea>
      </Container>

      {(!!event?.description2?.trim() || !!event?.event_map) && (
        <S.DescriptionWrapper>
          <Container>
            <>
              {!!event?.description2?.trim() && (
                <S.DescriptionSection>
                  <S.DescTitle>Descrição</S.DescTitle>
                  <S.DescTexts
                    dangerouslySetInnerHTML={{
                      __html: parseEmojis(event.description2),
                    }}
                  />
                </S.DescriptionSection>
              )}

              {event?.event_map && (
                <>
                  <S.DescTitle>Mapa do evento</S.DescTitle>
                  <S.MapEvent
                    src={event.event_map}
                    alt={`Mapa do evento ${event?.name ?? ""}`.trim()}
                  />
                </>
              )}
            </>
          </Container>
        </S.DescriptionWrapper>
      )}

      <Footer />
    </S.Page>
  )
}

export default Home
